import { FC, CSSProperties } from 'react'

type Props = {
  // eslint-disable-next-line react/require-default-props
  styles?: CSSProperties
}

const Circle: FC<Props> = ({ styles = {} }) => {
  return (
    <div
      style={{
        width: '8px',
        height: '8px',
        backgroundColor: 'black',
        borderRadius: '100%',
        flexShrink: 0,
        transform: 'translateY(5px)',
        ...styles
      }}
    />
  )
}

export default Circle
